;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.AccountBuilder = Model.AccountBuilder.extend({
		setCustomInit: function(){

			this.set('game', 'Essendon Tipping');

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));